<template>
  <div>
    <div class="modal fade" id="create-task-modal" aria-hidden="false" aria-labelledby="exampleGrid" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-simple modal-center">
        <div class="modal-content">
          <form autocomplete="off" >
            <div class="modal-header">
              <div class="container">
                <div class="row header">
                  <div class="col-8">
                    <h4 class="modal-title">{{ editTask ? $t('calendar.tasks.edit_task') : $t('calendar.tasks.create_task') }}</h4>
                  </div>
                  <div class="col-4">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="closeModal('#create-task-modal')">
                      <span aria-hidden="true" class="close-btn">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group form-material">
                    <label class="control-label" for="task-title">
                      {{ $t("calendar.tasks.title") }}
                    </label>
                    <span class="required">*</span>
                    <input
                      type="text"
                      class="form-control"
                      id="task-title"
                      v-model="newTask.title"
                    >
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label" for="task-description">
                      {{ $t("calendar.tasks.description") }}
                    </label>
                    <textarea
                      class="form-control"
                      id="task-description"
                      v-model="newTask.description"
                      cols="30" rows="5"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="control-label" for="task-notes">
                      {{ $t("input.notes") }}
                    </label>
                    <textarea
                      class="form-control"
                      id="task-notes"
                      v-model="newTask.notes"
                      cols="30" rows="5"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group form-material">
                    <label class="control-label" for="task-assigned-to">
                      {{ $t("calendar.tasks.assigned_to") }}
                    </label>
                    <select class="form-control" id="task-assigned-to" v-model="newTask.assigned_to">
                      <option :value="null">Unassigned</option>
                      <option :value="member.id" v-for="member in members">{{ `${member.first_name} ${member.last_name}` }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group form-material due-date">
                    <label class="control-label" for="task-due-date">
                      {{ $t("calendar.tasks.due_date") }}
                    </label>
                    <span class="required">*</span>
                    <datepicker
                      class="form-control"
                      id="task-due-date"
                      v-model="newTask.due_date"
                      format="dd D MMMM yyyy"
                      :disabled-dates="disabledPastDates.disabled"
                    ></datepicker>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group form-material">
                    <label class="control-label" for="task-rental">
                      {{ $t("calendar.tasks.rental") }}
                    </label>
                    <span class="required">*</span>
                    <select
                      class="form-control"
                      id="task-rental"
                      v-model="newTask.rental_id"
                    >
                      <option :value="rental.id" v-for="rental in rentals">{{ rental.name }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer text-center">
              <v-loading
                :isLoading="smallLoading"
                :height="50"
                :width="50"
                :viewbox="'0 0 50 50'"
                :cx="25"
                :cy="25"
                :r="22"
                :isHeightAuto="true"
              />
              <button
                type="button"
                class="btn waves-effect waves-classic btn-cancel"
                @click.prevent="closeModal('#create-task-modal')"
                data-dismiss="modal"
                :disabled="smallLoading"
              >
                {{ $t("button.cancel") }}
              </button>
              <button
                type="button"
                class="btn waves-effect waves-classic btn-save btn-red"
                @click.prevent="editTask ? updateTask() : createTask()"
                :disabled="smallLoading"
              >
                {{ editTask ? $t("button.update") : $t("button.create") }}
              </button>
              <button
                v-if="editTask"
                type="button"
                class="btn waves-effect waves-classic btn-save btn-red"
                @click.prevent="deleteTask()"
                :disabled="smallLoading"
              >
                {{ $t("button.delete") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "../../../../mixins/mixin";
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import taskService from '../../../../services/task';

export default {
name: "CreateTask",
  data() {
    return {
      newTask: {},
      defaultNewTask: {
        status: 1,
        title: '',
        description: '',
        rental_id: '',
        due_date: '',
        assigned_to: null,
        checked: false
      },
      editTask: false,
      assigned_to_type: null,
      smallLoading: false
    }
  },
  mixins: [mixin],
  components: {
    Datepicker,
    VLoading: require('components/loading/loading.vue'),
  },
  props: [
    'members',
    'rentals',
    'editedTask'
  ],
  methods: {
    async createTask() {
      this.smallLoading = true;
      await taskService.store(this, this.newTask);
      this.$emit('getTasks');
      mixpanel.track("web.calendar.tasks.create");
    },
    async updateTask() {
      this.smallLoading = true;
      await taskService.update(this, this.newTask, this.newTask.id);
      this.$emit('getTasks');
    },
    deleteTask() {
      this.closeModal('#create-task-modal');
      swal({
          title: this.$t('rentals.detail.modals.are_you_sure'),
          text: `<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div></div>`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: this.$t("rentals.detail.modals.yes_delete_it"),
          closeOnConfirm: false,
          html: true
        },
        async () => {
          $(".cancel").addClass("disabled");
          $(".confirm").addClass("disabled");
          $(".pulseWarning").hide();
          $("#loading1").show();

          await taskService.destroy(this, this.newTask.id);
          this.$emit('getTasks');
        });
    }
  },
  watch: {
    'newTask.due_date': function(date) {
      this.newTask.due_date = moment(date).format('YYYY-MM-DD')
    },
    'editedTask': function (task) {
      if (task) {
        this.editTask = true;
        this.newTask = {...task}
      }
    }
  },
  computed: {
    disabledPastDates() {
      let today = new Date();
      return {
        disabled : {
          to: new Date(today.setDate(today.getDate() - 1)),
          from: null
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CreateTask.vue?7f72c4ed